module.exports = __webpack_public_path__ + "static/media/Credit Video Version 1.60e85542.webm";